<template>
  <div class="containerDiv">
    <PCNavbar selectIndex="gw2"/>
    <MobileNavBar :currentActive="1"/>
    <!-- 头部banner图片 -->
    <img class="bannerImgcss0" :src="require(`@/assets/bannner/jituanjianjie.png`)" />
    <!-- <img class="bannerImgcss0" loading="lazy" src="../assets/bannner/jituanjianjie.png" /> -->

     

    <!-- 二级菜单切换 -->
    <div class="production_card">
     
      <Menu1 class="menu1css" :procardList="procardList" />
    </div>
     
    
           


  </div>
</template>

<script>
import Menu1 from '@/components/gk/menu1'

import PCNavbar from '@/components/navbar/index'
import MobileNavBar from '@/components/navbar/MobileNavBar.vue'
import CarouselHome1 from '@/components/carousel_home/index1'
 
export default {
  components: {
    PCNavbar,
    MobileNavBar,
    CarouselHome1,
    
    Menu1
  },
  data() {
    return {
      procardList: [
        {
          tit: '集团简介',
        },
        {
          tit: '组织架构',
        },
        {
          tit: '主要企业',
        },
        {
          tit: '产业布局',
        },
        {
          tit: '发展大事记',
        }
      ],
     
      
    }
  },
 

}
</script>

<style lang="scss" scoped>
.bannerImgcss0{
  width:100%;
  // margin-top:50px;
  height:auto;
}
.menu1css{
  margin-top:-1rem;
}
.containerDiv{
   min-width: 1000px;
   background: #ffffff;
   display: flexbox;
   overflow: hidden;
  .production_card {
    width: 100vw;
    min-height: 65vh;
    // margin: 0 auto;
    background: #ffffff;
  }
}
.bottom_circle {
  width: 100%;
  text-align: center;
  padding-top: 100px;
  background-image: url(../assets/img/smalldot.png),url(../assets/img/smalldot1.png);
  background-position: 0 0,110% 150%;
  background-repeat: no-repeat;
  background-size: 400px;
  h1 {
    font-size: 40px;
    padding-bottom: 20px;
    @media screen and (max-width: 768px) {
      font-size: 1.15rem;
      width: 60%;
      margin: 0 auto;
    }
  }
  
  .circle_img {
    width: 100%;
    img {
      width: 70%;
      @media screen and (max-width: 768px) {
        width: 100%;
        margin: 20PX 0;
      }
    }
  }

 
}
</style>